import { useEffect } from "react";
import liff from "@line/liff";
import axios from "axios";
import { useHistory } from 'react-router-dom';
import { TOKENUSERINFO } from "../../store/Login/Action";
import { useStateValue } from "../../store/state";
import request from "../../request";
import { toast } from "react-toastify";

const LineCallback = () => {
  const history = useHistory();  // Use useHistory for React Router v5
  const [{ }, dispatch] = useStateValue();

  useEffect(() => {
    const verifyLogin = async () => {
      try {
        await liff.init({ liffId: request.REACT_APP_LINE_LIFF_ID });

        if (!liff.isLoggedIn()) {
          history.replace("/login");
          toast.error("Line login failed");
          return
        }

        const idToken = liff.getIDToken();

        // Node API call here to Line Token verification
        const response = await axios.post(
          request.lineLoginTokenVerification,
          { id_token: idToken }
        );

        const success = response?.data?.success;
        const data = response?.data?.data;

        if (success === true && data?.token) {
          await TOKENUSERINFO(dispatch, data.token, history, null, { checkTerms: true });
        } else {
          history.replace("/login"); // redirect to Line
          toast.error("Line login failed");
        }
      } catch (error) {
        console.error("catch LineCallback error", error);
        history.replace("/login");
        toast.error("Line login failed");
      }
    };

    verifyLogin();
  }, []);

  return <div>Logging you in via LINE...</div>;
};

export default LineCallback;